"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTitle = exports.StyledSubtitle = exports.StyledRootHeader = exports.StyledRootCard = exports.StyledHeader = exports.StyledContent = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledRootCard = _styledComponents.default.div.withConfig({
  displayName: "style__StyledRootCard",
  componentId: "sc-dmuye4-0"
})(["width:", ";height:", ";background:", ";border:2px solid transparent;border-radius:4px;box-sizing:border-box;:hover{", "}:focus{outline:none;background:", ";", "}", ";"], ({
  width
}) => width && width, ({
  height
}) => height ? height : 'auto', _shared.theme.palette.brand.primary.white, ({
  hoverState
}) => hoverState && `background: ${_shared.theme.palette.ui.neutral.grey5};`, _shared.theme.palette.brand.primary.white, ({
  selected
}) => !selected && `
    border: 2px solid ${_shared.theme.palette.ui.cta.yellow};
		`, ({
  selected
}) => selected && `border: 2px solid ${_shared.theme.palette.ui.cta.blue}`);

exports.StyledRootCard = StyledRootCard;

const StyledRootHeader = _styledComponents.default.div.withConfig({
  displayName: "style__StyledRootHeader",
  componentId: "sc-dmuye4-1"
})(["font-family:", ";padding-bottom:", ";margin-bottom:", ";", ";"], _shared.theme.typography.link.fontFamily, _shared.theme.typography.link.fontSize, _shared.theme.typography.link.lineHeight, ({
  borderBottom
}) => borderBottom && ` border-bottom: 1px solid ${`${_shared.theme.palette.brand.primary.gray}30`};`);

exports.StyledRootHeader = StyledRootHeader;

const StyledHeader = _styledComponents.default.div.withConfig({
  displayName: "style__StyledHeader",
  componentId: "sc-dmuye4-2"
})(["", ";color:", ";margin-bottom:11px;"], _shared.theme.typography.body.css, _shared.theme.palette.brand.primary.charcoal);

exports.StyledHeader = StyledHeader;

const StyledTitle = _styledComponents.default.div.withConfig({
  displayName: "style__StyledTitle",
  componentId: "sc-dmuye4-3"
})(["", ";color:", ";margin-bottom:4px;"], _shared.theme.typography.h5.css, _shared.theme.palette.brand.primary.charcoal);

exports.StyledTitle = StyledTitle;

const StyledSubtitle = _styledComponents.default.div.withConfig({
  displayName: "style__StyledSubtitle",
  componentId: "sc-dmuye4-4"
})(["", ";color:", ";"], _shared.theme.typography.h6.css, _shared.theme.palette.brand.primary.gray);

exports.StyledSubtitle = StyledSubtitle;

const StyledContent = _styledComponents.default.div.withConfig({
  displayName: "style__StyledContent",
  componentId: "sc-dmuye4-5"
})(["box-sizing:border-box;padding:24px;&:focus{outline:none;border:none;}"]);

exports.StyledContent = StyledContent;